var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "pc-main"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-top"
  }, [_c('el-carousel', {
    attrs: {
      "height": "700px"
    }
  }, [_c('el-carousel-item', [_c('video', {
    staticClass: "bannertow-video",
    attrs: {
      "muted": "",
      "loop": "",
      "id": "indexvideo",
      "src": "https://col.jcdfkj.com/backend/static/video/publicize_company.mp4",
      "type": "video/mp4"
    },
    domProps: {
      "muted": true
    }
  }), _c('div', {
    staticClass: "video-text"
  }, [_c('div', {
    staticClass: "video-title"
  }, [_vm._v("让技术与生活更融洽")]), _c('div', {
    staticClass: "video-centent"
  }, [_vm._v("期待与您一起构建智能未来")]), _c('div', {
    staticClass: "video-btn",
    on: {
      "click": function ($event) {
        _vm.getunderstand = true;
      }
    }
  }, [_vm._v("了解更多")])])]), _c('el-carousel-item', [_c('div', {
    staticClass: "home-banner-swiper",
    style: {
      backgroundImage: 'url(' + require('../../../assets/pcimg/home_banner_1.png') + ')'
    }
  })]), _c('el-carousel-item', [_c('div', {
    staticClass: "home-banner-swiper home-banner-swiper-style",
    style: {
      backgroundImage: 'url(' + require('../../../assets/pcimg/home_banner_1_1.png') + ')'
    }
  })])], 1)], 1), _c('div', {
    staticClass: "box-center"
  }, [_c('p', {
    staticClass: "box-center-p"
  }, [_vm._v("服务领域")]), _vm._m(0), _c('div', {
    staticClass: "box-center-item"
  }, _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "box-center-item-1-1",
      on: {
        "click": function ($event) {
          return _vm.getserve(item.id);
        }
      }
    }, [_c('div', {
      staticClass: "item1"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "item2"
    }, [_vm._v(" " + _vm._s(item.serviceTitle) + " ")]), _c('div', {
      staticClass: "item3"
    }, [_vm._v(" " + _vm._s(item.serviceContent) + " ")])]);
  }), 0)]), _c('div', {
    staticClass: "box-center2"
  }, [_c('div', {
    staticClass: "box-center3-title1-1 wow fadeInUp"
  }, [_vm._v("专业的IDC服务")]), _vm._m(1), _c('el-carousel', {
    staticClass: "box-center2-el-carousel",
    attrs: {
      "height": "150px"
    }
  }, _vm._l(_vm.swipew, function (item, index) {
    return _c('el-carousel-item', {
      key: item.index,
      staticClass: "box-center2-el-carousel-item"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item1"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "item2"
    }, [_c('p', [_vm._v(_vm._s(item.idcTitle))]), _c('div', {
      staticClass: "item2-1",
      domProps: {
        "innerHTML": _vm._s(item.idcContent)
      }
    }), _c('div', {
      staticClass: "item2-btn",
      on: {
        "click": function ($event) {
          return _vm.btnidc(index);
        }
      }
    }, [_vm._v("查看详情")])])])]);
  }), 1)], 1), _c('div', {
    staticClass: "box-center3"
  }, [_c('div', {
    staticClass: "box-center3-title1 wow fadeInDown"
  }, [_vm._v("公司服务")]), _vm._m(2), _c('div', {
    staticClass: "box-center3-serve wow fadeInDown"
  }, [_c('div', {
    staticClass: "serve-lift"
  }, [_c('div', {
    class: _vm.serveId == 2 ? 'serve-lift-itemocer' : 'serve-lift-item',
    on: {
      "mouseover": function ($event) {
        return _vm.getserverun(2);
      }
    }
  }, [_c('div', {
    staticClass: "serve-lift-item-text"
  }, [_c('div', {
    staticClass: "item-text-text"
  }, [_vm._v(" " + _vm._s(_vm.operation.operatorTitle) + " ")]), _c('div', {
    staticClass: "item-text-item"
  }, _vm._l(_vm.operation.keywords, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item) + " /")])]);
  }), 0)]), _c('div', {
    staticClass: "serve-lift-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.operation.img,
      "alt": ""
    }
  })])]), _c('div', {
    class: _vm.serveId == 1 ? 'serve-lift-itemocer' : 'serve-lift-item',
    on: {
      "mouseover": function ($event) {
        return _vm.getserverun(1);
      }
    }
  }, [_c('div', {
    staticClass: "serve-lift-item-text"
  }, [_c('div', {
    staticClass: "item-text-text"
  }, [_vm._v(" " + _vm._s(_vm.systemIntegration.isrTitle) + " ")]), _c('div', {
    staticClass: "item-text-item"
  }, _vm._l(_vm.systemIntegration.keywords, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item) + " /")])]);
  }), 0)]), _c('div', {
    staticClass: "serve-lift-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.systemIntegration.img,
      "alt": ""
    }
  })])]), _c('div', {
    class: _vm.serveId == 0 ? 'serve-lift-itemocer' : 'serve-lift-item',
    on: {
      "mouseover": function ($event) {
        return _vm.getserverun(0);
      }
    }
  }, [_c('div', {
    staticClass: "serve-lift-item-text"
  }, [_c('div', {
    staticClass: "item-text-text"
  }, [_vm._v(" " + _vm._s(_vm.weakCurrentEngineering.engineerTitle) + " ")]), _c('div', {
    staticClass: "item-text-item"
  }, _vm._l(_vm.weakCurrentEngineering.keywords, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item) + " /")])]);
  }), 0)]), _c('div', {
    staticClass: "serve-lift-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.weakCurrentEngineering.img,
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "serve-rigth"
  }, [_vm.serveId == 2 ? _c('div', {
    staticClass: "serve-rigth-item"
  }, [_c('div', {
    staticClass: "serve-rigth-item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.operation.operatorContent)
    }
  }), _c('div', {
    staticClass: "serve-rigth-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.operation.detailImg,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "serve-btn"
  }, [_c('div', {
    staticClass: "serve-btn1"
  }), _c('div', {
    staticClass: "serve-btn2",
    on: {
      "click": _vm.getgetintegration
    }
  }, [_vm._v("查看详情")])])]) : _vm._e(), _vm.serveId == 1 ? _c('div', {
    staticClass: "serve-rigth-item"
  }, [_c('div', {
    staticClass: "serve-rigth-item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.systemIntegration.isrContent)
    }
  }), _c('div', {
    staticClass: "serve-rigth-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.systemIntegration.detailImg,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "serve-btn"
  }, [_c('div', {
    staticClass: "serve-btn1"
  }), _c('div', {
    staticClass: "serve-btn2",
    on: {
      "click": _vm.getintegration
    }
  }, [_vm._v("查看详情")])])]) : _vm._e(), _vm.serveId == 0 ? _c('div', {
    staticClass: "serve-rigth-item"
  }, [_c('div', {
    staticClass: "serve-rigth-item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.weakCurrentEngineering.engineerContent)
    }
  }), _c('div', {
    staticClass: "serve-rigth-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.weakCurrentEngineering.detailImg,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "serve-btn"
  }, [_c('div', {
    staticClass: "serve-btn1"
  }), _c('div', {
    staticClass: "serve-btn2",
    on: {
      "click": _vm.getweakCurrent
    }
  }, [_vm._v("查看详情")])])]) : _vm._e()])])]), _c('div', {
    ref: "statisticsRef",
    staticClass: "box-center4"
  }, [_c('img', {
    staticClass: "box-center4-img",
    attrs: {
      "src": require("../../../assets/pcimg/statistics.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "box-center4-top"
  }, _vm._l(_vm.statistics, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "box-center4-top-item"
    }, [_vm._m(3, true), _c('div', {
      staticClass: "item-rigth"
    }, [_c('div', {
      staticClass: "quantity"
    }, [_c('animate-number', {
      attrs: {
        "from": "0",
        "to": item.number || 0,
        "duration": "1000"
      }
    }), index < 2 ? _c('span', {
      staticClass: "year"
    }, [_vm._v("年")]) : _vm._e(), item.companyIsShow ? _c('span', [_vm._v("万")]) : _vm._e(), index > 0 ? _c('span', {
      staticClass: "yeares"
    }, [_vm._v("+")]) : _vm._e()], 1), _c('div', {
      staticClass: "wire"
    }), _c('div', {
      staticClass: "texttext"
    }, [_vm._v(_vm._s(item.text))])])]);
  }), 0), _vm._m(4)]), _c('div', {
    staticClass: "box-center5"
  }, [_c('div', {
    staticClass: "box-center5-title-title wow fadeInDown"
  }, [_vm._v("新闻资讯")]), _vm._m(5), _c('div', {
    staticClass: "box-center5-bottom"
  }, [_c('div', {
    staticClass: "box-center5-bottom-lift wow fadeInLeft",
    on: {
      "click": function ($event) {
        return _vm.getjournalism(_vm.mainjournalism.id);
      }
    }
  }, [_c('div', {
    staticClass: "box-center5-bottom-lift-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.mainjournalism.newsImg,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "box-center5-bottom-lift-centent"
  }, [_c('div', {
    staticClass: "box-center5-bottom-lift-text1"
  }, [_vm._v(" " + _vm._s(_vm.mainjournalism.newsTitle) + " ")]), _c('div', {
    staticClass: "box-center5-bottom-lift-text2",
    domProps: {
      "innerHTML": _vm._s(_vm.mainjournalism.synopsisContent)
    }
  })])]), _c('div', {
    staticClass: "box-center5-bottom-right wow fadeInRight"
  }, _vm._l(_vm.journalism, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "box-center5-bottom-right-item",
      on: {
        "click": function ($event) {
          return _vm.getjournalism(item.id);
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "xinwenimg",
      attrs: {
        "src": item.newsImg,
        "alt": ""
      }
    })]), _c('div', [_c('span', {
      staticClass: "text1",
      domProps: {
        "innerHTML": _vm._s(item.newsTitle)
      }
    }), _c('span', {
      staticClass: "text2"
    }, [_vm._v(_vm._s(item.releaseTime))]), _c('p', {
      staticClass: "xian"
    }), _c('p', {
      staticClass: "text3",
      domProps: {
        "innerHTML": _vm._s(item.synopsisContent)
      }
    })])]);
  }), 0)]), _c('div', {
    staticClass: "box-center5-btn",
    on: {
      "click": _vm.gengduo
    }
  }, [_vm._v("了解更多")])]), _c('div', {
    staticClass: "box-center6"
  }, [_c('img', {
    class: _vm.backgroundImage,
    attrs: {
      "src": this.backgroundImg,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "center6-box"
  }, [_c('div', {
    staticClass: "box-center6-title-title wow fadeInDown",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("设计")]), _vm._m(6), _c('div', {
    staticClass: "box-center6-design wow fadeInDown"
  }, _vm._l(_vm.queryDesign, function (item, index) {
    return _c('div', {
      key: index,
      class: _vm.ids == index ? 'title2' : 'title',
      on: {
        "click": function ($event) {
          return _vm.gettitle(index, item.id, item.designTitle, item.designContent, item.backgroundImg);
        }
      }
    }, [_vm._v(" " + _vm._s(item.designTitle) + " ")]);
  }), 0), _c('div', {
    staticClass: "design-box wow fadeInUp"
  }, [_c('transition', {
    attrs: {
      "name": "myfade"
    }
  }, [_c('div', {
    staticClass: "box-center6-item",
    class: _vm.animate__flash
  }, _vm._l(_vm.queryDesignDetail, function (items, index) {
    return _c('div', {
      key: index,
      staticClass: "box-center6-item1",
      on: {
        "click": function ($event) {
          return _vm.APPitem(items, _vm.itemtitle, _vm.itemId, index);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": items.img,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "box-center6-item1-bottom"
    }, [_c('p', [_vm._v(_vm._s(items.designTitle))])]), _vm.itemId == 3 && _vm.itemtitle == '海报设计' && index == 0 ? _c('div', {
      staticClass: "ding1"
    }, [_vm._v(" 每日海报 ")]) : _vm._e()]);
  }), 0)])], 1), _c('div', {
    staticClass: "design-box-btn",
    on: {
      "click": _vm.getdesignadd
    }
  }, [_vm._v("查看更多")])])]), _c('div', {
    staticClass: "box-center8"
  }, [_c('div', {
    staticClass: "box-center5-title-title wow fadeInDown",
    staticStyle: {
      "color": "#ffffff",
      "margin-top": "91px"
    }
  }, [_vm._v(" " + _vm._s(_vm.cowCooperativePartnerGetInfo.title) + " ")]), _c('div', {
    staticClass: "box-center5-title wow fadeInDown"
  }, [_vm._v(" " + _vm._s(_vm.cowCooperativePartnerGetInfo.subheading) + " ")]), _c('div', {
    staticClass: "box-center8-center wow fadeInUp"
  }, [_vm._l(_vm.cowCooperativePartnerDetailList1, function (items, index) {
    return _c('div', {
      key: items.id,
      staticClass: "box-center8-center-img"
    }, [_c('img', {
      attrs: {
        "src": items.img,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "company-name"
    }, [_c('span', {
      staticClass: "company-sapn"
    }, [_vm._v(_vm._s(items.enterpriseName))])])]);
  }), _c('div', {
    staticClass: "box-center8-center-num"
  }, [_c('div', {
    staticClass: "box-center8-center-num1"
  }, [_vm._v("合作伙伴案例")]), _c('div', {
    staticClass: "box-center8-center-num2"
  }, [_vm._v(" " + _vm._s(_vm.cowCooperativePartnerGetInfo.friendNum) + " ")])]), _vm._l(_vm.cowCooperativePartnerDetailList2, function (items, index) {
    return _c('div', {
      key: items.id,
      staticClass: "box-center8-center-img"
    }, [_c('img', {
      attrs: {
        "src": items.img,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "company-name"
    }, [_c('span', {
      staticClass: "company-sapn"
    }, [_vm._v(_vm._s(items.enterpriseName))])])]);
  }), _c('div', {
    staticClass: "addmore",
    on: {
      "click": _vm.getaddmore
    }
  })], 2)])])]), _vm.getunderstand ? _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.getunderstand,
      "center": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.getunderstand = $event;
      }
    }
  }, [_c('div', {
    staticClass: "aboutvideo"
  }, [_c('video', {
    staticClass: "banner-video",
    attrs: {
      "id": "indextcvideo",
      "loop": "",
      "muted": "",
      "autoplay": "",
      "controls": "",
      "src": _vm.getCowVideos,
      "type": "video/mp4"
    },
    domProps: {
      "muted": true
    }
  }), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function ($event) {
        _vm.getunderstand = false;
      }
    }
  })])])], 1) : _vm._e(), _c('div', {
    staticClass: "mobile-main"
  }, [_c('mobileIndex')], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2"
  }, [_vm._v("一站式的品牌数字服务体系")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2 wow fadeInUp",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(" 一站式的品牌数字服务体系 ")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2 wow fadeInDown"
  }, [_vm._v("为您提供专业贴心的服务")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "item-lift"
  }, [_c('div', {
    staticClass: "item-lift-xian"
  }), _c('div', {
    staticClass: "item-lift-quan"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center4-bottom"
  }, [_c('div', [_vm._v("用心，用行动，为客户持续创造价值")]), _c('div', [_vm._v("致力于成为企业认可的互联网战略合作伙伴")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2 wow fadeInDown"
  }, [_vm._v("NEWS")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center6-title"
  }, [_c('div', {
    staticClass: "box-center6-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center6-title2 wow fadeInDown",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(" 为您提供精美的界面设计 ")]), _c('div', {
    staticClass: "box-center6-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}];
export { render, staticRenderFns };